import React, {FC} from 'react';
import styled from 'styled-components';

/*
 * Style.
 */

const StyledFooterActionsDiv = styled.div`
  display: flex;
  margin-top: 20px;
  margin-left: -6px;
  margin-right: -6px;

  & > * {
    margin: 0 5px;
  }
`;

/*
 * Component.
 */

export const InfoBubbleFooterActions: FC = (props) => (
  <StyledFooterActionsDiv>{props.children}</StyledFooterActionsDiv>
);
